/* eslint-disable no-unused-vars */
import { queryUuIdInfo, upLoadFile } from "@/api/common"
import { queryNumber, savePreRecordInfo } from "@/api/personalCenter.js"

import axios from 'axios';

// 创建一个 Axios 实例
const axiosInstance = axios.create({
	baseURL: `${process.env.VUE_APP_BASE_API}`, // 替换为你的 API 地址
});

import Resumable from 'resumablejs';

export default function (config) {
	let {
		lotteryType = '', //彩种
		lotteryName = '', //彩种
	} = config;
	return {
		created () {
			console.log('彩种', lotteryType);
		},
		data () {
			return {
				// 分片上传 start
				resumable: null,
				file: null,
				// 分片上传 end


				uploadFile_loading: false,

				// 新加的  start
				saveLoading: false,
				// 新加的  end

				form: {
					"recordId": "",
					"title": "",
					"preType": lotteryType,
					"number": "",
					"curScore": 0,
					"totalScore": 0,
					"preRemark": "",
					createUser: '',
					productModel: '0', //商品所属模块：商品类别:0（预测缩水单商品），1（EXCEL专场商品），2（缩水软件特区商品；【product_model】
					backNumber: '20',

					"preRecordDetailDtoList": [
						// {
						//     "detailId": "",
						//     "recordId": "",
						//     "title": "",
						//     "preType": "",
						//     "preRemark": "",
						//     "number": "",
						//     "isWin": "",
						//     "winNo": "",
						//     "expand": "",
						//     "preIndexType": "",
						//     "realBetNumber": "",
						//     "useStatus": "",
						//     "backNumber": "",
						//     "id": ""
						// }
					]
				}
			}
		},
		async mounted () {
			// 获取当前彩种最新期号
			queryNumber(lotteryType).then(res => this.form.number = res.data.next)
			this.form.recordId = await queryUuIdInfo()

			this.form.createUser = this.vuex_userInfo.userId
		},
		methods: {
			// 处理杀6围4
			async jianting_inp (e) {
				const expand = e.target.value;
				const preIndexType = e.target.dataset.type;

				let isFindType = this.form.preRecordDetailDtoList.findIndex(item => item.preIndexType == preIndexType)

				if (isFindType === -1) {
					let { number } = this.form
					this.form.preRecordDetailDtoList.push({
						// id: await queryUuIdInfo(),
						id: this.form.recordId,
						title: `双色球第（${number}）期缩水预测 `,
						// realBetNumber:'' ,     //文件行数上传文件成功后有返回
						preIndexType,		//指标标识
						number,
						preType: lotteryType,	//彩种
						expand,	//输入的数字   围3杀5这些

						createUser: this.vuex_userInfo.userId,
						productModel: '0', //商品所属模块：商品类别:0（预测缩水单商品），1（EXCEL专场商品），2（缩水软件特区商品；【product_model】
						backNumber: '20',
					})
				} else {
					this.$set(this.form.preRecordDetailDtoList[isFindType], 'expand', expand)
				}

			},

			// 处理选择文件
			async chooseFile (e) {
				// this.uploadFile_loading = true

				// 解决文件上传时，第二次文件和第一次文件相同浏览器没反应的问题
				// this.handleFileChange(e)

				const inputElement = e.target;
				const parentDiv = inputElement.parentNode;

				let { number, recordId: bizId, } = this.form

				let preIndexType = e.target.getAttribute('data-type')
				let fileType = e.target.getAttribute('data-fileType')
				let formData = new FormData();
				formData.append('file', e.target.files[0])

				let paramsUrl = new URLSearchParams({ bizId, fileType, number, }).toString();
				let url = '/stage-api/commonFile/upLoadFile?' + paramsUrl

				axiosInstance.post(url, formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
						'Authorization': 'Bearer ' + this.vuex_token,
					},
					// 【P0 修复】文件上传设置 120 秒超时，避免无限等待
					timeout: 120000,
					onUploadProgress: (progressEvent) => {
						// 计算进度百分比
						const progressPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);

						let uploadText = document.createElement('i');

						uploadText.innerText = `上传中...${progressPercentage}%`;
						uploadText.style.display = 'block'
						uploadText.style.fontSize = '12px'
						uploadText.style.color = 'blue';

                        if(!parentDiv.querySelector('i')){
                            parentDiv.appendChild(uploadText)
                        } else{
                            parentDiv.querySelector('i').innerText = `上传中...${progressPercentage}%`
                        }

					},
				}).then(response => {
					response = response.data
					let realBetNumber = response.data.bizId + '_' + fileType.toUpperCase();

					// 上传成功标记：用内联 SVG 绘制，不依赖字体，任何设备都能正常显示
					parentDiv.querySelector('i').innerHTML = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#67c23a" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="4,13 9,18 20,6"></polyline></svg>`;

					// 继续后续逻辑
					let upload_params = {
						id: response.data.fileId,
						title: `${lotteryName}第(${number})期缩水预测`,
						realBetNumber: response.data[realBetNumber],
						preIndexType,
						number,
						preRemark: '',
						preType: lotteryType,
						createUser: this.vuex_userInfo.userId,
						productModel: '0',
						backNumber: '20',
					};

					let isFindType = this.form.preRecordDetailDtoList.findIndex(item => item.preIndexType == preIndexType);

					if (isFindType === -1) {
						this.form.preRecordDetailDtoList.push(upload_params);
					} else {
						this.$set(this.form.preRecordDetailDtoList, isFindType, upload_params);
					}

				}).catch(err => {
					console.log('err', err);
					this.$message.error('上传失败')
				})

				// 最原始版本
				// upLoadFile('?' + paramsUrl, formData).then(res => {
				// 	this.uploadFile_loading = false
				// 	let realBetNumber = res.data.bizId + '_' + fileType.toUpperCase()

				// 	let upload_params = {
				// 		id: res.data.fileId,
				// 		title: `${lotteryName}第(${number})期缩水预测`,   //标题
				// 		realBetNumber: res.data[realBetNumber],  //文件行数,上传文件后返回的
				// 		preIndexType,		//指标名称
				// 		number,			//期号
				// 		preRemark: '',	//输入的数字   围3杀5这些
				// 		preType: lotteryType, //彩种

				// 		createUser: this.vuex_userInfo.userId,
				// 		productModel: '0', //商品所属模块：商品类别:0（预测缩水单商品），1（EXCEL专场商品），2（缩水软件特区商品；【product_model】
				// 		backNumber: '20',
				// 	}

				// 	console.log('upload_params', upload_params);

				// 	let isFindType = this.form.preRecordDetailDtoList.findIndex(item => item.preIndexType == preIndexType)

				// 	console.log('isFindType', isFindType);

				// 	if (isFindType == -1) {
				// 		this.form.preRecordDetailDtoList.push(upload_params)
				// 	} else {
				// 		this.$set(this.form.preRecordDetailDtoList, isFindType, upload_params)
				// 	}

				// })
			},

			handleFileChange (event) {
				const input = event.target;
				const newInput = input.cloneNode(true); // 创建一个新的 input 元素
				input.parentNode.replaceChild(newInput, input); // 替换旧的 input 元素
				newInput.value = ''; // 清空新 input 的值
				newInput.addEventListener('change', this.handleFileChange); // 重新绑定事件
			},

			save () {
				this.saveLoading = true
				this.form.title = this.form.title || `[${this.vuex_userInfo.userName}]${lotteryName}第(${this.form.number})期缩水预测`
				savePreRecordInfo(this.form).then(res => {
					if (res.header.ret == 0) {
                        this.$alert('发布成功',{
                            showClose:false,
                            closeOnPressEscape:false,
                            center:true,
                        })
						this.resetForm()
					} else {
						this.$message.error(res.header.msg)
					}
				// eslint-disable-next-line no-unused-vars
				}).finally(_=>{
                    this.saveLoading = false
                })
			},

			resetForm () {
				this.form = {
					"recordId": "",
					"title": "",
					"preType": lotteryType,
					"number": "",
					"curScore": 0,
					"totalScore": 0,
					"preRemark": "",
					"preRecordDetailDtoList": []
				}

				document.querySelectorAll('input').forEach(item => {
					item.value = ''
				})
			},

		}
	}
}
